import { PalPage, PalTypography } from "@palamar/fe-library";

import { Grid } from "@mui/material";

import DateFilter from "./ReportFilterComponents/DateFilter";
import DateRangeFilter from "./ReportFilterComponents/DateRangeFilter";
import NumberRangeFilter from "./ReportFilterComponents/NumberRangeFilter";
import SelectFilter from "./ReportFilterComponents/SelectFilter";
import TextFilter from "./ReportFilterComponents/TextFilter";

/* 
Filter Component JSON Layout:

{
  "type": "filter",
  "filter_type": string // ["date_range", "date", "select", "text"]
  "params": string[] // length is 2 for date_range, 1 for the others

  // optional properties
  "display_name": string // for display
  "options": {"label": string, "value": any}[] //for select and multiple_select
  "props": any // for custom component props (e.g. label, placeholder, multiple, isPrimitiveValue etc.)
*/
const ReportFilter = ({ filter }) => {
  const { filter_type, ...rest } = filter;

  return (
    <PalPage>
      <Grid container spacing={2}>
        {filter.display_name ? (
          <Grid item xs={12}>
            <PalTypography variant="subtitle2">{filter.display_name}</PalTypography>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          {filter_type === "date_range" && <DateRangeFilter {...rest} />}
          {filter_type === "select" && <SelectFilter {...rest} />}
          {filter_type === "text" && <TextFilter {...rest} />}
          {filter_type === "date" && <DateFilter {...rest} />}
          {filter_type === "number_range" && <NumberRangeFilter {...rest} />}
        </Grid>
      </Grid>
    </PalPage>
  );
};
export default ReportFilter;
